import { render, staticRenderFns } from "./GiveAccess.vue?vue&type=template&id=2ed2e1f6&"
import script from "./GiveAccess.vue?vue&type=script&lang=js&"
export * from "./GiveAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports